import React from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { authActions } from "../../../redux/actions/auth.action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fieldLengthConstants, translationConstants } from "../../../constants";
import { ToastifyService } from "../../../services";

const ForgotPasswordForm = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    const { email } = data;

    try {
      // Dispatch the emailVerification action and pass the email as an argument.
      dispatch(authActions.emailVerification(email, navigate,props.setShowForgotPasswordModal));
    } catch (error) {
      ToastifyService.showError(error);
    }
  };

  return (
    <Form noValidate onSubmit={handleSubmit(onSubmit)}>
      <span className="ForgotParaHeading">
        {t(translationConstants.forgotPassword)}
      </span>
      <span className="recoveryPara mb-3 mt-1">
        {t(translationConstants.recoverPasswordInstruction)}
      </span>
      <Form.Group className="form-group">
        <Form.Label>{t(translationConstants.enterYourEmail)}</Form.Label>
        <Form.Control
          {...register("email", {
            required: t(translationConstants.emailRequired),
            pattern: {
              value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,}$/i,
              message: t(translationConstants.invalidEmail),
            },
          })}
          id="email"
          type="email"
          maxLength={fieldLengthConstants.EMAIL_FIELD_LENGTH}
          placeholder={t(translationConstants.emailPlaceholder)}
        />
        {errors.email && <p className="errorText">{errors.email.message}</p>}
      </Form.Group>

      <Button className="Submit-button  " type="submit">
        {t(translationConstants.submit)}
      </Button>
    </Form>
  );
};

export default ForgotPasswordForm;
